// Measure against resting slots, never transformed icons: the animation must not feed
// its own displacement back into the next pointer measurement.
export function getDockMagnification(count: number, active: number | null) {
  const growth = Array.from({ length: count }, (_, index) => {
    if (active === null) return 0

    const distance = Math.min(Math.abs(index - active) / 1.8, 1)
    return ((1 + Math.cos(distance * Math.PI)) / 2) * 0.36
  })
  const totalGrowth = growth.reduce((total, value) => total + value, 0)
  let precedingGrowth = 0

  return growth.map((value) => {
    // Accumulate the actual added width so every gap stays the same. Center the
    // expanded row as a whole instead of independently pushing individual icons.
    const shift = precedingGrowth + value / 2 - totalGrowth / 2
    precedingGrowth += value

    return { scale: 1 + value, shift }
  })
}
